import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationContentBlockerStatisticsGet = {
    path: "/template/content-blockers/statistics",
    method: ERouteHttpVerb.GET
};
export { routeLocationContentBlockerStatisticsGet };
